module.exports = __webpack_public_path__ + "img/image-1.adf0ef01.png";